<template>
    <modal v-if="createRunsModalOpen" @close="createRunsModalOpen = false" ref="createRunsModal" :is-closeable="true" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Create Runs</h3>
        </template>

        <slot>
            <div class="form-row">
                <div class="col">
                    <form-input label="Start From Date" v-model="formData.create_runs_from_date" type="date" />
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="createRunsModalOpen = false">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="createRuns()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>

    <modal size="lg" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Create Runs</h3>
        </template>

        <slot>
            <div class="form-row">
                <div class="col">
                    <form-input label="Start From Date" v-model="formData.create_runs_from_date" type="date" />
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="createRunsModalOpen = false">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="createRuns()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import moment from 'moment'

export default {
    props: ['client'],
    mixins: [FormMixin, ModalMixin],
    components: {},
    emits: ['updated', 'close', ],
    data() {
        const data = {
            formData: {
                create_runs_from_date: moment()
            }
        }

        return data
    },
    mounted() {},
    computed: {},
    methods: {
        createRuns() {
            const url = `/admin/clients/${this.client.id}/payroll/create-runs`

            this.$store.dispatch('START_LOADING')
            this.$api.post(url, {create_runs_from_date: this.formData.create_runs_from_date}).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
                this.close()
            }).catch((errors) => {
                if (errors.__status__ == 403) {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.$emit('no-access')
                    return
                }
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>

<style lang="scss">
</style>
